import React from 'react';
import { Box, Card, Typography, CardContent, CardMedia, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import { ArrowForward } from '@mui/icons-material';

function AppCard({ app }) {
  return (
    <Card
      component={Link}
      to={`/api/admin/app/${app._id}`}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        borderRadius: 3,
        overflow: 'hidden',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        border: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 12px 40px rgba(99, 102, 241, 0.2)',
          '& .app-card-image': {
            transform: 'scale(1.05)',
          },
          '& .app-card-arrow': {
            transform: 'translateX(4px)',
          },
        },
      }}
    >
      {/* Image Section */}
      <Box
        sx={{
          position: 'relative',
          paddingTop: '60%',
          overflow: 'hidden',
          backgroundColor: 'grey.100',
        }}
      >
        <CardMedia
          component="img"
          image={app.image}
          alt={app.title}
          className="app-card-image"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease',
          }}
        />
        {/* Gradient Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)',
          }}
        />
      </Box>

      {/* Content Section */}
      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          p: 2.5,
        }}
      >
        <Typography
          variant="h6"
          fontWeight="600"
          gutterBottom
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            color: 'text.primary',
            mb: 2,
          }}
        >
          {app.title}
        </Typography>

        {/* Footer */}
        <Box
          sx={{
            mt: 'auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Chip
            label="Active"
            size="small"
            sx={{
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              color: 'success.main',
              fontWeight: 600,
              fontSize: '0.75rem',
            }}
          />
          <ArrowForward
            className="app-card-arrow"
            sx={{
              color: 'primary.main',
              fontSize: 20,
              transition: 'transform 0.3s ease',
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default AppCard;
